/**
 * Simple event dispatcher for handling state changes in the SDK
 */
export type Listener<T> = (data: T) => void;

export class EventDispatcher<T> {
  private listeners: Set<Listener<T>> = new Set();

  subscribe(listener: Listener<T>): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  notify(data: T): void {
    this.listeners.forEach((listener) => {
      try {
        listener(data);
      } catch (error) {
        console.error('Error in event listener:', error);
      }
    });
  }

  clear(): void {
    this.listeners.clear();
  }
}

